import { Breakpoints } from 'JBSrc/constants';

jQuery($ => {

	//Blog sliders
	if($('.card__blogslider').length){
		$('.card__blogslider').each(function(){
			$(this).slick({
				infinite: true,
			  	slidesToShow: 3,
			  	slidesToScroll: 3,
				arrows: true,
				dots: false,
	            prevArrow: $('.card__blogslider__nextprev .slick-prev'),
	            nextArrow: $('.card__blogslider__nextprev .slick-next'),
				responsive: [
			    {
			      breakpoint: parseInt(Breakpoints.md),
			      settings: {
			        slidesToShow: 3,
			        slidesToScroll: 3,
			        infinite: true,
			        dots: true
			      }
			    },
			    {
			      breakpoint: parseInt(Breakpoints.sm),
			      settings: {
			        slidesToShow: 2,
			        slidesToScroll: 2
			      }
			    },
			    {
			      breakpoint: parseInt(Breakpoints.xs),
			      settings: {
					  slidesToShow: 1,
                      slidesToScroll: 1,
			      }
			    }
			  ]
			});
		});
	}
});
